import { useEffect } from 'react';
import { reportScreen } from '../../services/analyticsService';
import ContentHeader from '../../components/ContentHeader';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { Page } from '../../components/layout';
import OfferViewPage from '../../containers/OfferViewPage';

export default (props) => {
  useDocumentTitle('Offers');
  useEffect(() => {
    reportScreen('deal_page');
  }, []);

  return (
    <Page>
      <ContentHeader title="Offers" />
      <OfferViewPage {...props} />
    </Page>
  );
};
